<template>
  <ol class="breadcrumbs">
    <li v-for="item in crumbs" :key="item.name">
      <router-link :to="{ name: item.name }">{{ item.label }}</router-link>
    </li>
  </ol>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'breadcrumbs',
  computed: mapState({
    crumbs: state => state.breadcrumbs.crumbs,
  }),
  methods: mapActions('breadcrumbs', ['add']),
};
</script>

<style lang="scss">
.breadcrumbs {
  list-style-type: none;
  padding-left: 0;
  li {
    display: inline-block;
    padding-right: $padding/2;

    &:after {
      display: inline-block;
      content: '/';
      padding-left: $padding/2;
      color: $muted;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }

    a {
      &.router-link-exact-active {
        text-decoration: none;
        font-weight: 700;
      }
    }
  }
}
</style>
